module.exports = __webpack_public_path__ + "media/src/images/topic-8d4879bda9881c02c5d0d3ee74f90f9e.png";